module.exports = __webpack_public_path__ + "static/media/minpros.da571911.png";